import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { RouteComponentProps, useParams, withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { withStyles } from '@material-ui/core';
import { Location, selectLocationAvailabilityInitQuery } from './queries';
import styles from './styles';
import ViewAvailabilityComponent from '../../../../components/Global/Location/Common/components/StepAvailability';
import Dashboard from '../../../../layouts/Dashboard';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  location_id: string;
}

const OrgViewLocationAvailability = ({ classes }: Props): React.ReactElement => {
  const { location_id } = useParams<UrlParams>();

  const [location, setLocation] = useState<Location>({
    name: '',
    organisation_id: '',
  });

  const { data } = useQuery(selectLocationAvailabilityInitQuery(location_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && data) {
      setLocation(data.locations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [data]);

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Locations', link: '/org/locations' },
        { label: location.name, link: `/org/locations/${location_id}` },
        { label: 'Availability' },
      ]}>
      <ViewAvailabilityComponent classes={{}} location_id={location_id} organisation_id={location.organisation_id} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(OrgViewLocationAvailability));
